/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_RewindInputs */



/**
* | output |
* | --- |
* | "Toggle Rewind" |
*
* @param {Shortcut_Keys_Name_Toggle_RewindInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_rewind = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_RewindInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_RewindInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer retour rapide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurückspulen umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva riavvolgimento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить перемотку назад")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alternar rebobinar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换倒带")
	if (locale === "ja") return /** @type {LocalizedString} */ ("巻き戻しを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिवाइंड टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar retroceder")
	return /** @type {LocalizedString} */ ("Toggle Rewind")
});